import ScInput from "@/src/components/ui-kit/input";
import { EditProfileFormValues } from "@/src/models/user.model";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";

type WorkDetailsSectionProps = Readonly<{
  control: Control<EditProfileFormValues>;
  canEditFields: boolean;
}>;

const WorkDetailsSection = ({
  control,
  canEditFields,
}: WorkDetailsSectionProps) => {
  // See ScInput: React Compiler must be off for these RHF Controller fields or
  // initially-empty inputs reject typed input.
  "use no memo";
  const { t } = useTranslation();

  return (
    <View className="gap-4 md:border-t pt-4 md:border-ash-3">
      <Text className="font-semibold text-base text-onyx">
        {t("LABEL_WORK_DETAILS_OPTIONAL")}
      </Text>

      <Controller
        control={control}
        name="designation"
        render={({ field: { value, onChange } }) => (
          <ScInput
            label="LABEL_DESIGNATION"
            placeholder="LABEL_ENTER_DESIGNATION"
            value={value}
            onChangeText={onChange}
            editable={canEditFields}
          />
        )}
      />

      <View className="flex-col md:flex-row gap-4">
        <View className="flex-1">
          <Controller
            control={control}
            name="department"
            render={({ field: { value, onChange } }) => (
              <ScInput
                label="LABEL_DEPARTMENT"
                placeholder="LABEL_ENTER_DEPARTMENT"
                value={value}
                onChangeText={onChange}
                editable={canEditFields}
              />
            )}
          />
        </View>
        <View className="flex-1">
          <Controller
            control={control}
            name="company"
            render={({ field: { value, onChange } }) => (
              <ScInput
                label="LABEL_COMPANY"
                placeholder="LABEL_ENTER_COMPANY_NAME"
                value={value}
                onChangeText={onChange}
                editable={canEditFields}
              />
            )}
          />
        </View>
      </View>

      <Controller
        control={control}
        name="website"
        render={({ field: { value, onChange } }) => (
          <ScInput
            label="LABEL_WEBSITE"
            placeholder="LABEL_ENTER_COMPANY_WEBSITE_URL"
            value={value}
            onChangeText={onChange}
            editable={canEditFields}
          />
        )}
      />
    </View>
  );
};

export default WorkDetailsSection;
